var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1OutdoorSiren1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.88 40L25.17 11.67 11.36 29 30 40.83V57H10v4h24V43.36l10 6.35 5.51-2L56 52l10-4.24-5.79-4.09L68.88 40zM44 45L17.26 28 26 17l34 22-16 6z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Outdoor_siren_1.24192c10.svg";
export { SvgG1OutdoorSiren1 as ReactComponent };